import { useImperativeHandle, useRef } from 'react'

import { useFeedback } from '../../hooks/useFeedback'
import { isAudio, isImage, isOfficeFile, isVideo } from '../../utils/mimeType'

import { PreviewFileProps, PreviewFileRef } from './interface'
import { PreviewAudio } from './PreviewAudio'
import { PreviewImage } from './PreviewImage'
import { PreviewOffice } from './PreviewOffice'
import { PreviewVideo } from './PreviewVideo'

export const PreviewFile = ({ ref }: PreviewFileProps) => {
  const { message } = useFeedback()

  const previewImageRef = useRef<PreviewFileRef>(null)
  const previewVideoRef = useRef<PreviewFileRef>(null)
  const previewAudioRef = useRef<PreviewFileRef>(null)
  const PreviewOfficeRef = useRef<PreviewFileRef>(null)

  useImperativeHandle(ref, () => {
    return {
      open(current, files) {
        if (isImage(current.type)) {
          previewImageRef.current?.open(current, files)
        } else if (isOfficeFile(current.type)) {
          PreviewOfficeRef.current?.open(current)
        } else if (isVideo(current.type)) {
          previewVideoRef.current?.open(current)
        } else if (isAudio(current.type)) {
          previewAudioRef.current?.open(current)
        } else {
          message.warning('文件无法预览')
        }
      }
    }
  })

  return (
    <>
      <PreviewImage ref={previewImageRef} />
      <PreviewVideo ref={previewVideoRef} />
      <PreviewAudio ref={previewAudioRef} />
      <PreviewOffice ref={PreviewOfficeRef} />
    </>
  )
}
